<app-nav titulo="Cotizaciones" descripcion="Aquí podrá ver, editar y borrar todas las cotizaciones.">
    <div class="quotes">
        <div class="buttons">
            <button mat-raised-button class="garantor-button fast-quote-button" (click)="abrirCotizacionRapida()">
                <span class="add-button-label">Cotización Rápida</span>
            </button>
            <button mat-raised-button color="primary" class="garantor-button quote-button" routerLink="./nueva" *ngIf="this.userType !== 'AGENTE'">
                <span class="add-button-label">Nueva cotización</span>
            </button>
        </div>
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="quotes"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateQuotes($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Comenzar garantía con esta cotización" class="generate-warranty-button" [routerLink]="row.tipoProducto === 'ADMINISTRACION_ALQUILER' ? '/admin-alquileres/nueva' : '/garantias/nueva'" [queryParams]="{ quoteId: row.id }" *ngIf="(userType === 'AGENTE' || userType === 'CORPORATIVO') && !row.idGarantia">
            <mat-icon color="primary">assignment_turned_in</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Borrar cotización" class="delete-row-button" (click)="deleteQuote(row)" *ngIf="userType === 'AGENTE' || userType === 'CORPORATIVO'">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
